import React, { useEffect, useState, useContext, useRef, useMemo } from 'react'
import './searchItems.css'
import { getParameterByName } from '../../../utils/commonFunctions'
import ProductContext from '../../../Product/context/product/productContext'
import AuthContext from '../../../Product/context/auth/authContext'
import NoRecordsFound from '../../../Product/components/atoms/NoRecordsFound'
import SearchProductList from '../../../Component/ProductCard/product'
import GridProduct from '../../../Component/ProductCard/gridProduct'
import Layout from '../Layout'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import FilterPanel from '../../../Product/components/organisms/FilterPanel'
import Loaders from '../../../Product/components/molecules/Loaders'
import { Button, Drawer, SwipeableDrawer } from '@material-ui/core'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import SlidePanel from '../../../Component/SlidePanel'
import MultisellerListCard from '../../../Component/ProductCard/MultisellerListCard'
import MultisellerSlider from '../../../Component/SlidePanel/MultisellerSlider'
import CustomSelect from '../../../Product/components/atoms/Inputs/CustomSelect'
import { messageHandler } from '../../../Product/common/socketHandler'
import AlertContext from '../../../Product/context/alert/alertContext'
import PaginationComponent from '../../../Component/Pagination'
import { socket, socketAuction } from '../../../Product/common/socket'
import Slider from 'react-slick'
import PrimaryButton from '../../../Product/components/atoms/PrimaryButton'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { handleRedirectInternal, useCustomMediaQuery } from '../../../Product/common/components'
import { Link, useHistory, useLocation, matchPath } from 'react-router-dom'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import HeaderSearchComponent from '../Header/HeaderSearch'
import { sustainabilityOptions, brandsliqutatios, allCondition } from '../../../utils'
import SEO from '../../../utils/CommonFunctionality/SEO'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'
import { setAuthToken } from '../../../Product/common/api'
import CheckBox from '../../../Product/components/atoms/CheckBox'
import moment from 'moment-timezone'
import { debounce } from 'lodash'
import Popup from '../../../Product/components/organisms/Popup'
import axios from 'axios'

const useStyles = makeStyles({
    fullList: {
        width: 'auto',
    },
})

const AuctionSearchComponent = (props) => {
    // const [cookies, setCookie] = useCookies(['user_session'])
    const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent)
    const history = useHistory()

    const productContext = useContext(ProductContext)
    const alertContext = useContext(AlertContext)
    const authContext = useContext(AuthContext)
    const [state, setState] = useState({
        right: false,
        bottom: false,
        data: {},
    })
    const { search_allproducts, getAllSearchProducts, search_allauctions, productLocalState } =
        productContext
    const [auctionView, setAuctionView] = useState('Grid')
    {
        console.log(search_allproducts, 'search_allauctions')
    }
    const { isAuthenticated, user } = authContext
    const { setAlert } = alertContext

    const classes = useStyles()

    const isBidDepotProject = document.body.classList[1] == 'BidAuctionDepot'
    const checkThemeClassName = document.body.className == 'liquidationTwo primeBids'
    const isWizardTheme = document.body.classList[1] == 'wizardTheme'
    const isPrimeBids = global.storeConfigration?.bodyClass?.value == 'primeBids'
    const [isLoading, setLoading] = useState(true)
    const [viewProduct, setViewProduct] = useState([])
    const [searchCategories, setSearchCategories] = useState([])
    const [states, setStates] = useState([])
    const [listview, setlistview] = useState(false)
    const [totalItems, setTotalItem] = useState(0)
    const [selectedProduct, setSelectedProduct] = useState(null)
    const [cat_val, setCatVal] = useState([])
    const [isFilterVisible, setFilterVisible] = useState(true)
    const [modalOpen, setModalOpen] = useState(false)
    const viewProductRef = useRef(viewProduct)
    const userRef = useRef(user)
    const location = useLocation()
    const forMobile = useMediaQuery('(max-width:1024px)')
    const params = new URLSearchParams(window.location.search.substring(1))
    const [auctionIdRedirect, setAuctionIdRedirect] = useState(null)
    let idOfProduct = viewProduct?.findIndex((product) => product.lotof === auctionIdRedirect)

    const isBuyNowMatch = matchPath(location.pathname, {
        path: '/buynow',
        exact: false,
    })

    const [initialMinMax, setInitialMinMax] = useState({
        minCurPrice: null,
        maxCurPrice: null,
        minRetailPrice: null,
        maxRetailPrice: null,
    })

    const [curStateSlider, setCurStateSlider] = useState({
        fromprice: [0, 0],
    })
    const [retailStateSlider, setRetailStateSlider] = useState({
        mfromprice: [0, 0],
    })

    var filterValues = []
    const checkBidShopTheme = document.body.className == 'liquidationTwo bidShop'
    const debouncedFetchProducts = useRef(
        debounce((values) => getAllSearchProducts(values), 300),
    ).current

    const [sortbyfilter, setSortByFilter] = useState({
        orderby: typeof params.get('sort') !== 'undefined' ? params.get('sort') : '15',
        orderby2: '',
        sortType:
            typeof params.get('sort') !== 'undefined'
                ? params.get('sort') == 14
                    ? 1
                    : params.get('sort') == 15
                    ? 2
                    : ''
                : 2,
    })

    const manageFilterPanel = () => {
        setFilterVisible(!isFilterVisible)
    }

    const updateTermsStatus = async () => {
        const body = {
            site_id: global.storeDetails.site_id,
            user_id: user?.id,
            auction_id: auctionIdRedirect,
        }

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BASE_URL}api/updateUserTermsForAuction`,
                body,
            )

            if (response.data.success) {
                setModalOpen(false)
                handleRedirectInternal(history, `search?auctionId=${auctionIdRedirect}`)
            } else {
                setAlert('Terms and conditions not accepted', 'error')
            }
        } catch (error) {
            console.error('Error updating terms status:', error)
        }
    }

    // Sets product and user refrences on page load
    useEffect(() => {
        userRef.current = user
        viewProductRef.current = viewProduct
    })

    const handler = (message, type) => {
        messageHandler(
            message,
            viewProductRef.current,
            userRef.current,
            setAlert,
            setViewProduct,
            type,
        )
    }
    useEffect(() => {
        socket.on('realclosedupdates', (data) => {
            handler(data, 'realclosedupdates')
        })
        socket.on('bidAddtime', (data) => {
            handler(data, 'bidAddtime')
        })
        socket.on('buyer_assurance', (data) => {
            handler(data, 'buyer_assurance')
        })
        socketAuction.on('realclosedupdates', (data) => {
            handler(data, 'realclosedupdates')
        })
        socketAuction.on('bidAddtime', (data) => {
            handler(data, 'bidAddtime')
        })

        socketAuction.on('watchlist', (data) => {
            handler(data, 'watchlist')
            // handler2(data, 'watchlist')
        })
        socketAuction.on('product_view_count', (data) => {
            handler(data, 'product_view_count')
        })
        socket.on('cancelbidemitted', (data) => {
            handler(data, 'cancelbidemitted')
        })

        socket.on('watchlist', (data) => {
            handler(data, 'watchlist')
            // handler2(data, 'watchlist')
        })
        socket.on('product_view_count', (data) => {
            handler(data, 'product_view_count')
        })

        return () => {
            socket.off('realclosedupdates', (data) => {
                handler(data, 'realclosedupdates')
            })
            socket.off('bidAddtime', (data) => {
                handler(data, 'bidAddtime')
            })
            socket.off('buyer_assurance', (data) => {
                handler(data, 'buyer_assurance')
            })

            socketAuction.off('watchlist', (data) => {
                handler(data, 'watchlist')
                // handler2(data, 'watchlist')
            })
            socketAuction.off('product_view_count', (data) => {
                handler(data, 'product_view_count')
            })

            socketAuction.off('realclosedupdates', (data) => {
                handler(data, 'realclosedupdates')
            })
            socketAuction.off('bidAddtime', (data) => {
                handler(data, 'bidAddtime')
            })
            socket.off('cancelbidemitted', (data) => {
                handler(data, 'cancelbidemitted')
            })

            socket.off('watchlist', (data) => {
                handler(data, 'watchlist')
                //   handler2(data, 'watchlist')
            })
            socket.off('product_view_count', (data) => {
                handler(data, 'product_view_count')
            })
        }
    }, [])
    const checkBeachThemeClassName = document.body.className == 'liquidationTwo beachLiquidation'
    const checkEmursTheme = document.body.className == 'liquidationTwo emursMck'

    const active_sorts = {
        sorts: {
            sortcategoryTypes: ['2', '4', '5', '7', '8'],
            sortconditionTypes: ['2', '3', '5', '6'],
            sortsubCategoryTypes: ['1', '2', '3'],
            sortlocations: ['1', '2', '3', '18', '20'],
            sortall_notifications: [],
            sortbusiness_category: [],
            sortvat_registration: [],
        },
    }
    const [searchbar] = useState(new URLSearchParams(window.location.search.substring(1)).get('q'))
    const [catg] = useState(new URLSearchParams(window.location.search.substring(1)).get('cat'))

    const extraFields = checkBidShopTheme
        ? {
              current: 1,
          }
        : {}

    const initialValues = {
        sh_limit: sessionStorage.getItem('sh_limit'),
        page: 1,
        orderby: global?.storeConfigration?.liquidation_filter_update?.value == 1 ? '15' : '',
        location: [],
        sortType: global?.storeConfigration?.liquidation_filter_update?.value == 1 ? 2 : undefined,
        state: [],
        city: [],
        auction_city:
            productLocalState.globalLocationFilter == 1
                ? [productLocalState.globalLocation]
                : productLocalState.globalLocationFilter == 2
                ? [productLocalState.globalLocation?.split(',')?.[0]?.trim()]
                : [],
        category: catg ? [catg] : [],
        contenthead5: [],
        subcategory: [],
        condition: [],
        rating_multiple_io: [],
        storedate: [],
        enddate: null,
        fromprice: 0,
        toprice: 0,
        totalpage: 5,
        lotof: '',
        searchbar: searchbar ? searchbar : '',
        miles: params.get('m') ? params.get('m') : '',
        from: '',
        // auctionId: params.get('auctionId'),
        comingsoon: params.get('status') ? parseInt(params.get('status')) : 0,
        closed_auction_list: 0,
        view_type: params.get('view') ? params.get('view') : 0,
        auction_io: 1,
        conditionunique: [],
        lotsize: ['1'],
        auction_state:
            productLocalState.globalLocationFilter == 1
                ? []
                : productLocalState.globalLocationFilter == 2
                ? [productLocalState.globalLocation?.split(',')?.[1]?.trim()]
                : [productLocalState.globalLocation],
        orderby2: global?.storeConfigration?.liquidation_filter_update?.value == 1 ? '' : '6',
        need_bid_increment: 1,
        mfromprice: 0,
        mtoprice: 0,
        special_events: params.get('auctionId') ? [params.get('auctionId')] : [],
        item_type: params.get('type') ? params.get('type') : 0,
        bundleSizeFrom: 0,
        bundleSizeTo: 0,
        auction_location: 1,
        viewers: 1,
        watchers: 1,
        ...extraFields,
    }

    const formik = useFormik({
        initialValues: initialValues,
    })

    const [viewFilter, setViewFilter] = useState([
        { id: 0, description: 'All' },
        { id: 1, description: 'Auction Lots' },
        { id: 2, description: 'Buy Now Lots' },
    ])

    const bundleSize = [
        { description: 'All', id: 0, bundleSizeFrom: 0 },
        { description: 'Bundle 5-10', id: 10, bundleSizeFrom: 5 },
        { description: 'Small 10-25', id: 25, bundleSizeFrom: 10 },
        { description: 'Medium 25-50', id: 50, bundleSizeFrom: 25 },
        { description: 'Large 50+', id: 100000000, bundleSizeFrom: 50 },
    ]

    const retailPrice = [
        { description: 'All', id: 0, startPrice: 0 },
        { description: 'Under $50', id: 50, startPrice: 0 },
        { description: '$50-$100', id: 100, startPrice: 50 },
        { description: '$100-$300', id: 300, startPrice: 100 },
        { description: '$300-$400', id: 400, startPrice: 300 },
        { description: '$400-$999', id: 999, startPrice: 400 },
        { description: '$1000-$1499', id: 1499, startPrice: 1000 },
        { description: '$1500-$1999', id: 1999, startPrice: 1500 },
        { description: '$2000 and Above', id: 100000000, startPrice: 2000 },
    ]

    if (checkThemeClassName) {
        filterValues.push(
            {
                title: 'Auctions',
                type: 'check',
                noLabel: true,
                name: 'special_events',
                int: 1,
                // class: 'col-12',
                options: search_allauctions?.results?.length
                    ? search_allauctions?.results
                          .sort((a, b) => new Date(a.date_closed) - new Date(b.date_closed))
                          .map((val) => {
                              return {
                                  description: moment(val.date_closed).format('MMMM Do (dddd)'),
                                  id: val.id,
                              }
                          })
                    : [],
                formik: formik,
            },
            {
                title: 'Retail Price',
                type: 'radio',
                name: 'mtoprice',
                noLabel: true,
                int: 1,
                // class: 'col-12',
                item: retailPrice,
                formik: formik,
                onChange: (e) => {
                    const value = e.target.value
                    const selectedRange = retailPrice.find((range) => range.id == value)

                    if (selectedRange) {
                        const { startPrice, id } = selectedRange

                        formik.setFieldValue('mfromprice', startPrice)
                        formik.setFieldValue('mtoprice', id)
                    }
                },
            },
            {
                title: 'Condition',
                type: 'check',
                name: 'rating_multiple_io',
                options: global.condition_data.map((item) => {
                    return {
                        ...item,
                        description: item.condition,
                        id: item.condition,
                    }
                }),
                formik: formik,
            },
            {
                title: 'Category',
                type: 'check',
                name: 'category',
                options:
                    searchCategories.length > 0 && global.storeConfigration?.cat_with_count?.value
                        ? searchCategories
                              .sort((a, b) => a.description.localeCompare(b.description))
                              .filter((main) => {
                                  return true
                              })
                        : global.searchCategories
                              .sort((a, b) => a.description.localeCompare(b.description))
                              .filter((main) => {
                                  return true
                              }),
                formik: formik,
            },
            {
                title: `Location${states.length > 1 ? 's' : ''}`,
                type: 'check',
                name: 'auction_city',
                options: states
                    .map((location) => {
                        let conditionChanged = {}
                        conditionChanged.description = location.city
                        conditionChanged.id = location.city
                        conditionChanged.name = location.city
                        conditionChanged.value = location.city
                        conditionChanged.active = 1
                        return conditionChanged
                    })
                    .filter((main) => {
                        return true
                    }),
                formik: formik,
            },
            {
                title: 'Type',
                type: 'radio',
                noLabel: true,
                name: 'item_type',
                int: 1,
                // class: 'col-12',
                item: [
                    { id: 0, description: 'All' },
                    { id: 1, description: 'Single Items' },
                    { id: 2, description: 'Pallets' },
                ],
                formik: formik,
                onChange: (e) => {
                    const value = e.target.value

                    const params = new URLSearchParams(window.location.search)
                    params.set('type', value)

                    history.replace({
                        pathname: location.pathname,
                        search: params.toString(),
                    })

                    if (value != 2) {
                        formik.setValues({
                            ...formik.values,
                            item_type: value,
                            bundleSizeFrom: 0,
                            bundleSizeTo: 0,
                        })
                    } else {
                        formik.setValues({
                            ...formik.values,
                            item_type: value,
                        })
                    }
                },
            },
            {
                title: 'Bundle Size',
                type: 'radio',
                name: 'bundleSizeTo',
                noLabel: true,
                int: 1,
                item: bundleSize,
                formik: formik,
                onChange: (e) => {
                    const value = e.target.value

                    const selectedRange = bundleSize.find((range) => range.id == value)

                    if (selectedRange) {
                        const { bundleSizeFrom, id } = selectedRange
                        formik.setValues({
                            ...formik.values,
                            item_type: 2,
                            bundleSizeFrom: bundleSizeFrom,
                            bundleSizeTo: id,
                        })
                    }
                },
            },
            {
                title: 'Auction Status',
                type: 'radio',
                noLabel: true,
                name: 'closed_auction_list',
                int: 1,
                // class: 'col-12',
                item: [
                    { id: 0, description: 'Live Items' },
                    { id: 1, description: 'Closed Items' },
                ],

                formik: formik,
            },
        )
    } else if (checkEmursTheme) {
        filterValues.push(
            {
                title: 'Events',
                type: 'check',
                noLabel: true,
                name: 'special_events',
                int: 1,
                // class: 'col-12',
                options: search_allauctions?.results?.length
                    ? search_allauctions?.results
                          .sort((a, b) => new Date(a.date_closed) - new Date(b.date_closed))
                          .map((val) => {
                              return {
                                  description: moment(val.date_closed).format('MMMM Do (dddd)'),
                                  id: val.id,
                              }
                          })
                    : [],
                formik: formik,
            },
            {
                title: 'Retail Price',
                type: 'radio',
                name: 'mtoprice',
                noLabel: true,
                int: 1,
                // class: 'col-12',
                item: retailPrice,
                formik: formik,
                onChange: (e) => {
                    const value = e.target.value
                    const selectedRange = retailPrice.find((range) => range.id == value)

                    if (selectedRange) {
                        const { startPrice, id } = selectedRange

                        formik.setFieldValue('mfromprice', startPrice)
                        formik.setFieldValue('mtoprice', id)
                    }
                },
            },
            {
                title: 'Condition',
                type: 'check',
                name: 'rating_multiple_io',
                options: global.condition_data.map((item) => {
                    return {
                        ...item,
                        description: item.condition,
                        id: item.condition,
                    }
                }),
                formik: formik,
            },
            {
                title: 'Category',
                type: 'check',
                name: 'category',
                options:
                    searchCategories.length > 0 && global.storeConfigration?.cat_with_count?.value
                        ? searchCategories
                              .sort((a, b) => a.description.localeCompare(b.description))
                              .filter((main) => {
                                  return true
                              })
                        : global.searchCategories
                              .sort((a, b) => a.description.localeCompare(b.description))
                              .filter((main) => {
                                  return true
                              }),
                formik: formik,
            },
            {
                title: `Location${states.length > 1 ? 's' : ''}`,
                type: 'check',
                name: 'auction_city',
                options: states
                    .map((location) => {
                        let conditionChanged = {}
                        conditionChanged.description = location.city
                        conditionChanged.id = location.city
                        conditionChanged.name = location.city
                        conditionChanged.value = location.city
                        conditionChanged.active = 1
                        return conditionChanged
                    })
                    .filter((main) => {
                        return true
                    }),
                formik: formik,
            },

            {
                title: 'Auction Status',
                type: 'radio',
                noLabel: true,
                name: 'closed_auction_list',
                int: 1,
                // class: 'col-12',
                item: [
                    { id: 0, description: 'Live Items' },
                    { id: 1, description: 'Closed Items' },
                ],

                formik: formik,
            },
        )
    } else if (isWizardTheme) {
        filterValues.push(
            {
                title: 'Current Price',
                type: 'range',
                fromName: 'fromprice',
                toName: 'toprice',
                label: true,
                int: 1,
                min: initialMinMax.minCurPrice ?? 0,
                max: initialMinMax.maxCurPrice ?? 0,
                step: 0.1,
                formik: formik,
                sliderState: curStateSlider,
                setSliderState: setCurStateSlider,
            },
            {
                title: 'Suggested Retail',
                type: 'range',
                fromName: 'mfromprice',
                toName: 'mtoprice',
                label: true,
                int: 1,
                min: initialMinMax.minRetailPrice ?? 0,
                max: initialMinMax.maxRetailPrice ?? 0,
                step: 0.1,
                formik: formik,
                sliderState: retailStateSlider,
                setSliderState: setRetailStateSlider,
            },
            {
                title: 'Closing Date',
                type: 'check',
                noLabel: true,
                name: 'special_events',
                int: 1,
                options: search_allauctions?.results?.length
                    ? search_allauctions.results
                          .sort((a, b) => new Date(a.date_closed) - new Date(b.date_closed))
                          .map((val) => ({
                              description: moment(val.date_closed).format('MMMM Do (dddd)'),
                              id: val.id,
                          }))
                    : [],
                formik: formik,
                onChange: (e) => {
                    const value = e.target.value

                    formik.setValues({
                        ...formik.values,

                        special_events: [value],
                    })
                },
            },
            {
                title: `Pick Up Location`,
                type: 'check',
                noLabel: true,
                name: 'auction_city',

                options: states.map((location) => ({
                    description: location.city,
                    id: location.city,
                    name: location.city,
                    value: location.city,
                    active: 1,
                })),
                formik: formik,
                // onChange: (e) => {
                //     const value = e.target.value

                //     formik.setValues({
                //         ...formik.values,

                //         auction_city: [value],
                //     })
                // },
            },
            {
                title: 'Category',
                type: 'check',
                name: 'category',
                options:
                    searchCategories.length > 0 && global.storeConfigration?.cat_with_count?.value
                        ? searchCategories
                              .sort((a, b) => a.description.localeCompare(b.description))
                              .filter((main) => {
                                  return true
                              })
                        : global.searchCategories
                              .sort((a, b) => a.description.localeCompare(b.description))
                              .filter((main) => {
                                  return true
                              }),
                formik: formik,
            },
            {
                title: 'Condition',
                type: 'check',
                name: 'rating_multiple_io',
                options: global.condition_data.map((item) => {
                    return {
                        ...item,
                        description: item.condition,
                        id: item.condition,
                    }
                }),
                formik: formik,
            },
        )
    } else if (checkBidShopTheme) {
        filterValues.push(
            {
                title: 'View',
                type: 'radio',
                noLabel: true,
                name: 'view_type',
                int: 1,
                // class: 'col-12',
                item: viewFilter,
                formik: formik,
            },
            {
                title: 'Retail Price',
                type: 'radio',
                name: 'mtoprice',
                noLabel: true,
                int: 1,
                // class: 'col-12',
                item: retailPrice,
                formik: formik,
                onChange: (e) => {
                    const value = e.target.value
                    const selectedRange = retailPrice.find((range) => range.id == value)

                    if (selectedRange) {
                        const { startPrice, id } = selectedRange

                        formik.setFieldValue('mfromprice', startPrice)
                        formik.setFieldValue('mtoprice', id)
                    }
                },
            },
            {
                title: 'Condition',
                type: 'check',
                name: 'rating_multiple_io',
                options: global.condition_data.map((item) => {
                    return {
                        ...item,
                        description: item.condition,
                        id: item.condition,
                    }
                }),
                formik: formik,
            },
            {
                title: 'Category',
                type: 'check',
                name: 'category',
                options:
                    searchCategories.length > 0 && global.storeConfigration?.cat_with_count?.value
                        ? searchCategories
                              .sort((a, b) => a.description.localeCompare(b.description))
                              .filter((main) => {
                                  return true
                              })
                        : global.searchCategories
                              .sort((a, b) => a.description.localeCompare(b.description))
                              .filter((main) => {
                                  return true
                              }),
                formik: formik,
            },
            {
                title: `Location${states.length > 1 ? 's' : ''}`,
                type: 'check',
                name: 'auction_city',
                options: states
                    .map((location) => {
                        let conditionChanged = {}
                        conditionChanged.description = location.city
                        conditionChanged.id = location.city
                        conditionChanged.name = location.city
                        conditionChanged.value = location.city
                        conditionChanged.active = 1
                        return conditionChanged
                    })
                    .filter((main) => {
                        return true
                    }),
                formik: formik,
            },
            {
                title: 'Auction Status',
                type: 'radio',
                noLabel: true,
                name: 'comingsoon',
                int: 1,
                // class: 'col-12',
                item: [
                    { id: 0, description: 'Live Items' },
                    { id: 2, description: 'Coming Soon' },
                ],

                formik: formik,
                onChange: (e) => {
                    const value = e.target.value

                    formik.setFieldValue('comingsoon', parseInt(value))

                    if (value == 0) {
                        formik.setFieldValue('current', 1)
                    } else {
                        formik.setFieldValue('current', 0)
                    }
                },
            },
        )
    } else {
        filterValues.push(
            {
                title: 'View',
                type: 'radio',
                noLabel: true,
                name: 'view_type',
                int: 1,
                // class: 'col-12',
                item: viewFilter,
                formik: formik,
            },
            {
                title: 'Retail Price',
                type: 'radio',
                name: 'mtoprice',
                noLabel: true,
                int: 1,
                // class: 'col-12',
                item: retailPrice,
                formik: formik,
                onChange: (e) => {
                    const value = e.target.value
                    const selectedRange = retailPrice.find((range) => range.id == value)

                    if (selectedRange) {
                        const { startPrice, id } = selectedRange

                        formik.setFieldValue('mfromprice', startPrice)
                        formik.setFieldValue('mtoprice', id)
                    }
                },
            },
            {
                title: 'Condition',
                type: 'check',
                name: 'rating_multiple_io',
                options: global.condition_data.map((item) => {
                    return {
                        ...item,
                        description: item.condition,
                        id: item.condition,
                    }
                }),
                formik: formik,
            },
            {
                title: 'Category',
                type: 'check',
                name: 'category',
                options:
                    searchCategories.length > 0 && global.storeConfigration?.cat_with_count?.value
                        ? searchCategories
                              .sort((a, b) => a.description.localeCompare(b.description))
                              .filter((main) => {
                                  return true
                              })
                        : global.searchCategories
                              .sort((a, b) => a.description.localeCompare(b.description))
                              .filter((main) => {
                                  return true
                              }),
                formik: formik,
            },
            {
                title: `Location${states.length > 1 ? 's' : ''}`,
                type: 'check',
                name: 'auction_city',
                options: states
                    .map((location) => {
                        let conditionChanged = {}
                        conditionChanged.description = location.city
                        conditionChanged.id = location.city
                        conditionChanged.name = location.city
                        conditionChanged.value = location.city
                        conditionChanged.active = 1
                        return conditionChanged
                    })
                    .filter((main) => {
                        return true
                    }),
                formik: formik,
            },
            {
                title: 'Type',
                type: 'radio',
                noLabel: true,
                name: 'item_type',
                int: 1,
                // class: 'col-12',
                item: [
                    { id: 0, description: 'All' },
                    { id: 1, description: 'Single Items' },
                    { id: 2, description: 'Pallets' },
                ],
                formik: formik,
                onChange: (e) => {
                    const value = e.target.value

                    const params = new URLSearchParams(window.location.search)
                    params.set('type', value)

                    history.replace({
                        pathname: location.pathname,
                        search: params.toString(),
                    })

                    if (value != 2) {
                        formik.setValues({
                            ...formik.values,
                            item_type: value,
                            bundleSizeFrom: 0,
                            bundleSizeTo: 0,
                        })
                    } else {
                        formik.setValues({
                            ...formik.values,
                            item_type: value,
                        })
                    }
                },
            },
            {
                title: 'Bundle Size',
                type: 'radio',
                name: 'bundleSizeTo',
                noLabel: true,
                int: 1,
                item: bundleSize,
                formik: formik,
                onChange: (e) => {
                    const value = e.target.value

                    const selectedRange = bundleSize.find((range) => range.id == value)

                    if (selectedRange) {
                        const { bundleSizeFrom, id } = selectedRange
                        formik.setValues({
                            ...formik.values,
                            item_type: 2,
                            bundleSizeFrom: bundleSizeFrom,
                            bundleSizeTo: id,
                        })
                    }
                },
            },
            {
                title: 'Auction Status',
                type: 'radio',
                noLabel: true,
                name: 'closed_auction_list',
                int: 1,
                // class: 'col-12',
                item: [
                    { id: 0, description: 'Live Items' },
                    { id: 1, description: 'Closed Items' },
                ],

                formik: formik,
            },
        )
    }

    const wizardFilterValues = useMemo(() => {
        if (!isWizardTheme) return []

        return [
            {
                title: 'Current Price',
                type: 'range',
                fromName: 'fromprice',
                toName: 'toprice',
                label: true,
                int: 1,
                min: initialMinMax.minCurPrice ?? 0,
                max: initialMinMax.maxCurPrice ?? 0,
                step: 0.1,
                formik: formik,
                sliderState: curStateSlider,
                setSliderState: setCurStateSlider,
            },
            {
                title: 'Suggested Retail',
                type: 'range',
                fromName: 'mfromprice',
                toName: 'mtoprice',
                label: true,
                int: 1,
                min: initialMinMax.minRetailPrice ?? 0,
                max: initialMinMax.maxRetailPrice ?? 0,
                step: 0.1,
                formik: formik,
                sliderState: retailStateSlider,
                setSliderState: setRetailStateSlider,
            },
            {
                title: 'Closing Date',
                type: 'radio',
                noLabel: true,
                name: 'special_events',
                int: 1,
                item: search_allauctions?.results?.length
                    ? search_allauctions.results
                          .sort((a, b) => new Date(a.date_closed) - new Date(b.date_closed))
                          .map((val) => ({
                              description: moment(val.date_closed).format('MMMM Do (dddd)'),
                              id: val.id,
                          }))
                    : [],
                formik: formik,
                onChange: (e) => {
                    const value = e.target.value

                    formik.setValues({
                        ...formik.values,

                        special_events: [value],
                    })
                },
            },
            {
                title: `Pick Up Location`,
                type: 'radio',
                noLabel: true,
                name: 'auction_city',

                item: states.map((location) => ({
                    description: location.city,
                    id: location.city,
                    name: location.city,
                    value: location.city,
                    active: 1,
                })),
                formik: formik,
                // onChange: (e) => {
                //     const value = e.target.value

                //     formik.setValues({
                //         ...formik.values,

                //         auction_city: [value],
                //     })
                // },
            },
            {
                title: 'Category',
                type: 'radio',
                name: 'category',
                noLabel: true,
                int: 1,
                item:
                    searchCategories.length > 0 && global.storeConfigration?.cat_with_count?.value
                        ? searchCategories.sort((a, b) =>
                              a.description.localeCompare(b.description),
                          )
                        : global.searchCategories.sort((a, b) =>
                              a.description.localeCompare(b.description),
                          ),
                formik: formik,
            },
            {
                title: 'Condition',
                type: 'radio',
                name: 'rating_multiple_io',
                noLabel: true,

                item: global.condition_data.map((item) => ({
                    ...item,
                    description: item.condition,
                    id: item.condition,
                })),
                formik: formik,
                // onChange: (e) => {
                //     const value = e.target.value

                //     formik.setValues({
                //         ...formik.values,

                //         rating_multiple_io: [value],
                //     })
                // },
            },
        ]
    }, [isWizardTheme, initialMinMax, curStateSlider, retailStateSlider, formik])

    useEffect(() => {
        if (search_allproducts.from === 'activeHeader') {
            return
        }

        if (search_allproducts.results.length > 0) {
            if (initialMinMax.minCurPrice === null) {
                setInitialMinMax({
                    minCurPrice: search_allproducts.minCurPrice || 0,
                    maxCurPrice: search_allproducts.maxCurPrice || 0,
                    minRetailPrice: search_allproducts.minRetailPrice || 0,
                    maxRetailPrice: search_allproducts.maxRetailPrice || 0,
                })

                setCurStateSlider({
                    fromprice: [
                        search_allproducts.minCurPrice || 0,
                        search_allproducts.maxCurPrice || 0,
                    ],
                })
                setRetailStateSlider({
                    mfromprice: [
                        search_allproducts.minRetailPrice || 0,
                        search_allproducts.maxRetailPrice || 0,
                    ],
                })
            }
        }
    }, [search_allproducts])

    useEffect(() => {
        formik.setFieldValue(
            'auction_state',
            productLocalState.globalLocationFilter == 1
                ? []
                : productLocalState.globalLocationFilter == 2
                ? [productLocalState.globalLocation?.split(',')?.[1]?.trim()]
                : [productLocalState.globalLocation],
        )
        formik.setFieldValue(
            'auction_city',
            productLocalState.globalLocationFilter == 1
                ? [productLocalState.globalLocation]
                : productLocalState.globalLocationFilter == 2
                ? [productLocalState.globalLocation?.split(',')?.[0]?.trim()]
                : [],
        )
        if (productLocalState.disableBuynowLocations?.includes(productLocalState.globalLocation)) {
            setViewFilter([{ id: 1, description: 'Auction Lots' }])
            formik.setFieldValue('view_type', 1)
        } else {
            setViewFilter([
                { id: 0, description: 'All' },
                { id: 1, description: 'Auction Lots' },
                { id: 2, description: 'Buy Now Lots' },
            ])

            if (checkBidShopTheme && isBuyNowMatch) {
                formik.setFieldValue('view_type', 1)
            } else {
                formik.setFieldValue('view_type', 0)
            }
        }
    }, [productLocalState.globalLocation])
    useEffect(() => {
        if (search_allproducts.from === 'activeHeader') {
            return
        }

        setLoading(false)

        // if (search_allproducts.from === 'searchPage') {
        if (search_allproducts.results.length > 0) {
            search_allproducts.results.map((data) => {
                if (data?.extra_fields?.includes('}')) {
                    let parse = JSON.parse(data.extra_fields)
                    Object.keys(parse).map((val) => {
                        data[val] = parse[val]
                    })
                }
            })
            setViewProduct(search_allproducts.results.length ? search_allproducts.results : [])
        } else {
            setViewProduct([])
        }
        if (
            search_allproducts?.categoriesCounts?.length > 0 &&
            searchCategories?.length == 0 &&
            global.storeConfigration?.cat_with_count?.value
        ) {
            const newCats = (global.searchCategories || []).map((value) => {
                const countObj = search_allproducts?.categoriesCounts?.find(
                    (val) => Number(val.category_id) === Number(value.id),
                )
                const catcount = countObj ? Number(countObj.CountCat) : 0
                const base = (value.description || '').replace(/\s*\(\d+\)\s*$/, '').trim()

                return {
                    ...value,
                    catcount,
                    description: `${base} (${catcount})`,
                }
            })

            setSearchCategories(newCats)
        }
        setTotalItem(search_allproducts.total_pagecnt)
        setStates(search_allproducts.city)
        // }
    }, [search_allproducts, formik.values])
    useEffect(() => {
        setViewProduct([])
        return () => {
            setViewProduct([])
        }
    }, [])

    const onHandlePage = (value) => {
        formik.setFieldValue('page', value)
        window.scrollTo(0, 0)
    }
    useEffect(() => {
        if (localStorage.token) {
            setAuthToken(localStorage.token)
        }
        setLoading(true)
        // if (formik.values.closed_auction_list) {
        //     formik.values.orderby = '7'
        // }
        const fromValue =
            formik.values.view_type == 1
                ? 'auction_only'
                : formik.values.view_type == 2
                ? 'buynow'
                : ''

        const updatedValues = { ...formik.values, from: fromValue }
        debouncedFetchProducts(updatedValues)

        !isWizardTheme ? window.scrollTo(0, 0) : null
    }, [isAuthenticated, formik.values])

    useEffect(() => {
        formik.setFieldValue('page', 1)
    }, [formik.values.view_type])
    useEffect(() => {
        const params = new URLSearchParams(window.location.search.substring(1))
        formik.setFieldValue('miles', params.get('m') ? params.get('m') : '')
        formik.setFieldValue('searchbar', params.get('q') ? params.get('q') : '')
        formik.setFieldValue('view_type', params.get('view') ? params.get('view') : 0)
        formik.setFieldValue('item_type', params.get('type') ? params.get('type') : 0)
        formik.setFieldValue(
            'closed_auction_list',
            params.get('status') && params.get('status') == 0 ? params.get('status') : 0,
        )
        formik.setFieldValue(
            'comingsoon',
            params.get('status') && params.get('status') == 2 ? params.get('status') : '',
        )
        if (global?.storeConfigration?.liquidation_filter_update?.value != 1) {
            formik.setFieldValue('orderby', params.get('sort') ? params.get('sort') : '')
        }
        if (params.get('cat') && !formik.values.category?.includes(params.get('cat'))) {
            formik.setFieldValue('category', params.get('cat') ? [params.get('cat')] : [])
        }
        if (typeof params.get('sort') !== 'undefined')
            setSortByFilter({
                orderby:
                    typeof params.get('sort') !== 'undefined'
                        ? params.get('sort')
                        : global?.storeConfigration?.liquidation_filter_update?.value == 1
                        ? '15'
                        : '',
                orderby2: '',
                sortType:
                    typeof params.get('sort') !== 'undefined'
                        ? params.get('sort') == 14
                            ? 1
                            : params.get('sort') == 15
                            ? 2
                            : ''
                        : global?.storeConfigration?.liquidation_filter_update?.value == 1
                        ? 2
                        : undefined,
            })
        setCatVal(formik.values.category)

        if (checkBidShopTheme && formik.values.comingsoon == 0) {
            formik.setFieldValue('current', 1)
        }
    }, [window.location.search])

    const toggleDrawer = (anchor, open, data) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return
        }
        if (open) {
            setState({ ...state, [anchor]: open, data: data })
        } else {
            setState({ ...state, [anchor]: open, data: {} })
        }
    }

    const handleClose = () => {
        params.delete('product')
        history.replace({
            pathname: location.pathname,
            search: params.toString(),
        })
        setSelectedProduct(null)
    }

    const handleClick = async (id) => {
        if (props.fromComponent === 'home') {
            setSelectedProduct(id)
        } else {
            params.set('product', id)

            history.replace({
                pathname: location.pathname,
                search: params.toString(),
            })
        }
    }

    useEffect(() => {
        var product_id = params.get('product')
        if (product_id && !selectedProduct) {
            setSelectedProduct(product_id)
        }
    }, [window.location.search])
    const pageOptions = [
        {
            value: '25',
            show: 'Results 25 per page',
        },
        {
            value: '50',
            show: 'Results 50 per page',
        },
        {
            value: '100',
            show: 'Results 100 per page',
        },
        {
            value: '150',
            show: 'Results 150 per page',
        },
    ]

    const sortShow1 = [
        {
            value: 15,
            show: 'Todays Top Deals',
        },
        {
            value: 3,
            show: 'Current price low to high',
        },
        {
            value: 11,
            show: 'Current price high to low',
        },

        {
            value: 16,
            show: 'Bid count hight to low',
        },
        {
            value: 17,
            show: 'Bid count low to high',
        },

        {
            value: 2,
            show: 'Recently listed',
        },
        {
            value: '',
            show: 'Deals Ending Soon',
        },
        {
            value: 14,
            show: 'Best Deals',
        },
    ]

    const sortShow = [
        {
            value: 15,
            show: 'Todays Top Deals',
        },
        {
            value: 3,
            show: 'Current price low to high',
        },
        {
            value: 11,
            show: 'Current price high to low',
        },
        {
            value: 16,
            show: 'Bid count hight to low',
        },
        {
            value: 17,
            show: 'Bid count low to high',
        },

        {
            value: 2,
            show: 'Recently listed',
        },
        {
            value: '',
            show: 'Deals Ending Soon',
        },
        {
            value: 14,
            show: 'Best Deals',
        },
    ]

    const [checked, setChecked] = useState(
        global?.storeConfigration?.liquidation_filter_update?.value == 1 ? false : true,
    )
    const settings = {
        dots: true,
        fade: true,
        arrows: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 4000,
        cssEase: 'linear',
    }
    const handleRedirect = (data) => {
        // console.log(data)
        // console.log(global.multipleBannersFields[data])
        if (!isAuthenticated) {
            handleRedirectInternal(history, 'sign-up')
        } else {
            // window.location.href = JSON.parse(
            //     global.multipleBannersFields[data].fields
            //         ? global.multipleBannersFields[data].fields
            //         : '{}',
            // ).btn_link
        }
    }
    const handleSortByFilter = (event) => {
        const value = event.target.value
        const params = new URLSearchParams(window.location.search)
        params.set('sort', value)
        history.replace({
            pathname: location.pathname,
            search: params.toString(),
        })
        if (value == '14') {
            if ('page' in formik.values) {
                formik.setFieldValue('page', 1)
            }
            setSortByFilter((prevValue) => {
                return {
                    ...prevValue,
                    orderby: value,
                    orderby2: '',
                    sortType: 1,
                }
            })
        } else if (value == '15') {
            if ('page' in formik.values) {
                formik.setFieldValue('page', 1)
            }
            setSortByFilter((prevValue) => {
                return {
                    ...prevValue,
                    orderby: value,
                    orderby2: '',
                    sortType: 2,
                }
            })
        } else if (value == '') {
            if ('page' in formik.values) {
                formik.setFieldValue('page', 1)
            }
            setSortByFilter((prevValue) => {
                return {
                    ...prevValue,
                    orderby: value,
                    orderby2: '6',
                    sortType: '',
                }
            })
        } else if (value == '11') {
            if ('page' in formik.values) {
                formik.setFieldValue('page', 1)
            }
            setSortByFilter((prevValue) => {
                return {
                    ...prevValue,
                    orderby: value,
                    orderby2: '',
                    sortType: '',
                }
            })
        } else if (value == '3') {
            if ('page' in formik.values) {
                formik.setFieldValue('page', 1)
            }
            setSortByFilter((prevValue) => {
                return {
                    ...prevValue,
                    orderby: value,
                    orderby2: '',
                    sortType: '',
                }
            })
        } else if (value == '2') {
            if ('page' in formik.values) {
                formik.setFieldValue('page', 1)
            }
            setSortByFilter((prevValue) => {
                return {
                    ...prevValue,
                    orderby: value,
                    orderby2: '',
                    sortType: '',
                }
            })
        } else if (value == '16') {
            if ('page' in formik.values) {
                formik.setFieldValue('page', 1)
            }
            setSortByFilter((prevValue) => {
                return {
                    ...prevValue,
                    orderby: value,
                    orderby2: '',
                    sortType: '',
                }
            })
        } else if (value == '17') {
            if ('page' in formik.values) {
                formik.setFieldValue('page', 1)
            }
            setSortByFilter((prevValue) => {
                return {
                    ...prevValue,
                    orderby: '',
                    orderby2: '',
                    sortType: '',
                }
            })
        }
    }
    useEffect(() => {
        if (global?.storeConfigration?.liquidation_filter_update?.value == 1) {
            if (formik.values.orderby !== sortbyfilter.orderby) {
                console.log('came to sort api')
                formik.setValues({
                    ...formik.values,
                    orderby: sortbyfilter.orderby,
                    orderby2: sortbyfilter.orderby2,
                    sortType: sortbyfilter.sortType,
                })
            }
        }
    }, [sortbyfilter])
    useEffect(() => {
        if (checked) {
            formik.setFieldValue('orderby2', `6`)
        } else {
            formik.setFieldValue('orderby2', ``)
        }
    }, [checked])
    useEffect(() => {
        if (
            global?.storeConfigration?.liquidation_filter_update?.value !== '1' &&
            formik.values.orderby == '2'
        ) {
            formik.setFieldValue('orderby2', '')
            setChecked(false)
        }
    }, [formik.values.orderby])
    const handleFilterDeleteAll = () => {
        if (cat_val.length > 0 || (searchbar !== null && searchbar !== '')) {
            handleRedirectInternal(history, 'search?q=&cat=&est=0&rat=&view=&sort=17&slimit=50')
            formik.setFieldValue('category', [])
            formik.setFieldValue('auction_city', [])
            formik.setFieldValue('rating_multiple_io', [])
            formik.setFieldValue('mtoprice', 0)
            formik.setFieldValue('mtoprice', 0)
            formik.setFieldValue('view_type', 0)
            formik.setFieldValue('item_type', 0)
            formik.setFieldValue('bundleSizeTo', 0)
            formik.setFieldValue('closed_auction_list', 0)
        } else {
            formik.setFieldValue('category', [])
            formik.setFieldValue('auction_city', [])
            formik.setFieldValue('rating_multiple_io', [])
            formik.setFieldValue('mtoprice', 0)
            formik.setFieldValue('view_type', 0)
            formik.setFieldValue('item_type', 0)
            formik.setFieldValue('bundleSizeTo', 0)
            formik.setFieldValue('closed_auction_list', 0)
        }

        formik.setFieldValue('toprice', 0)
        formik.setFieldValue('delivery', [])
        formik.setFieldValue('quality_rating', [])
        formik.setFieldValue('special_events', [])
        if (
            auctionTitle !== 'Flash Deals' &&
            auctionTitle !== 'Todays Top Deals' &&
            auctionTitle !== 'Recently Listed' &&
            auctionTitle !== 'Deals Ending Soon' &&
            auctionTitle !== 'Buy Now'
        ) {
            formik.setFieldValue('orderby', 17)
        }
        // handleRedirectInternal(history, 'search?q=&cat=&est=0&rat=&view=&sort=17&slimit=50')
    }

    const RemovalDate = ({ apiDate }) => {
        const date = new Date(apiDate)
        date.setDate(date.getDate() + 10)
        const displayDate = date.toLocaleDateString('en-US', {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
        })
        return (
            <strong>
                <span>{displayDate}</span>
            </strong>
        )
    }

    return (
        <Layout props={props}>
            {isPrimeBids ? (
                <SEOTAG page="Search" />
            ) : (
                <SEO title={`${global?.storeDetails?.name} | Search`} />
            )}
            {/* {global.multipleBannersFields.length ? (
                <div className="siteBanner multiple">
                    {
                        <Slider {...settings}>
                            {global.multipleBannersFields?.map((data, index) => (
                                <>
                                    <img
                                        src={
                                            process.env.REACT_APP_AUCTION_IMAGE_URL +
                                            '/' +
                                            data?.image_name
                                        }
                                    />
                                    <div className="bannerContent">
                                        <h2 className="pb-4">
                                            {JSON.parse(data.fields ? data.fields : '{}').title}
                                        </h2>
                                        <PrimaryButton
                                            label={
                                                isAuthenticated
                                                    ? JSON.parse(data.fields ? data.fields : '{}')
                                                          .btn_text
                                                    : 'Sign Up'
                                            }
                                            type="button"
                                            onClick={() =>
                                                !isAuthenticated
                                                    ? handleRedirectInternal(history, 'sign-up')
                                                    : (window.location.href = JSON.parse(
                                                          global.multipleBannersFields[index].fields
                                                              ? global.multipleBannersFields[index]
                                                                    .fields
                                                              : '{}',
                                                      ).btn_link)
                                            }
                                        />
                                    </div>
                                </>
                            ))}
                        </Slider>
                    }
                </div>
            ) : (
                <div className="siteBanner">
                    <LazyLoadImage
                        src={global?.storeDetails?.bannerValue}
                        alt={`${global?.storeDetails?.name} banner`}
                        effect="blur"
                        height="100%"
                        width="100%"
                    />
                    <div className="bannerContent">
                        <h2>{global?.storeDetails?.description}</h2>
                        <PrimaryButton
                            label="Explore Now"
                            onClick={() =>
                                handleRedirectInternal(
                                    history,
                                    `${isAuthenticated ? 'search' : 'sign-up'}`,
                                )
                            }
                        />
                    </div>
                </div>
            )} */}

            <div className="customContainer mt-5 position-relative " id="search-view">
                {forMobile ? (
                    <>
                        {isWizardTheme ? null : (
                            <div className="auctionsMiscFilter">
                                {global?.storeConfigration?.liquidation_filter_update?.value == 1 ||
                                checkBidShopTheme ? null : (
                                    <CheckBox
                                        name="orderby"
                                        label="Time Remaining"
                                        className="asdasd"
                                        checked={checked}
                                        onChange={(event) => setChecked(!checked)}
                                    />
                                )}

                                <div className="gridListToggle">
                                    <Button
                                        className={auctionView === 'Grid' ? 'active' : ''}
                                        onClick={() => setAuctionView('Grid')}
                                    >
                                        <span className="material-icons">apps</span>
                                    </Button>
                                    <Button
                                        className={auctionView === 'List' ? 'active' : ''}
                                        onClick={() => setAuctionView('List')}
                                    >
                                        <span className="material-icons">view_list</span>
                                    </Button>
                                </div>
                            </div>
                        )}
                        <div className="mblStckyFilter py-3">
                            <CustomSelect
                                label="Results per page"
                                name="resultsPerPage"
                                selectType="noBorder"
                                value={formik.values.sh_limit}
                                size="small"
                                onChange={(event, editor) => {
                                    formik.values.page = 1
                                    formik.setFieldValue('sh_limit', event.target.value)
                                    sessionStorage.setItem('sh_limit', event.target.value)
                                }}
                            >
                                {pageOptions.map((opt, optindex) => (
                                    <option value={opt.value}>{opt.show}</option>
                                ))}
                            </CustomSelect>

                            <CustomSelect
                                label="Sort by"
                                value={formik.values.orderby}
                                size="small"
                                selectType="noBorder"
                                name="orderby"
                                // shrink={search.orderby !== '' ? true : false}
                                onChange={(event, editor) => {
                                    {
                                        global?.storeConfigration?.liquidation_filter_update
                                            ?.value == 1 &&
                                        global?.storeConfigration?.liquidation_filter_update
                                            ?.value !== undefined
                                            ? handleSortByFilter(event)
                                            : formik.setFieldValue('orderby', event.target.value)
                                    }
                                }}
                            >
                                {global?.storeConfigration?.liquidation_filter_update?.value == 1
                                    ? sortShow1.map((opt, optindex) => (
                                          <option value={opt.value}>{opt.show}</option>
                                      ))
                                    : sortShow.map((opt, optindex) => (
                                          <option value={opt.value}>{opt.show}</option>
                                      ))}
                            </CustomSelect>
                            {useCustomMediaQuery('(max-width: 1024px)') && (
                                <Button
                                    className="filterButton w-100"
                                    variant="outlined"
                                    onClick={toggleDrawer('bottom', true)}
                                >
                                    Filters
                                </Button>
                            )}
                            {checkBeachThemeClassName ? (
                                ''
                            ) : (
                                <Button
                                    className="filterButton w-100"
                                    variant="outlined"
                                    onClick={() =>
                                        handleRedirectInternal(history, 'dashboard/mybids')
                                    }
                                >
                                    My Bids
                                </Button>
                            )}

                            {/* <Button
                                className="filterButton srchBtn w-100"
                                variant="outlined"
                                onClick={toggleDrawer('top', true)}
                            >
                                <span className="material-icons">search</span>
                            </Button> */}
                        </div>

                        <div className="auctionSearchPaginationTop">
                            <PaginationComponent
                                onPageChange={onHandlePage}
                                totalProductCount={totalItems}
                                currentPage={formik.values.page}
                                resultToShow={formik.values.sh_limit}
                            />
                        </div>
                    </>
                ) : (
                    <>
                        <div className="auctionSearchPaginationTop d-flex justify-content-between align-items-center flex-wrap my-5">
                            <div>
                                {checkBidShopTheme ? (
                                    <div
                                        className="d-flex align-items-center"
                                        style={{ gap: '15px' }}
                                    >
                                        <h2 className="bidSearchResults">Search Results</h2>
                                        <span>{viewProduct.length} items found</span>
                                    </div>
                                ) : null}
                                {useCustomMediaQuery('(min-width: 1024px)') && (
                                    <Button className="filterToggle" onClick={manageFilterPanel}>
                                        <span className="material-icons-outlined">filter_list</span>
                                        Filters
                                        <span className="material-icons-outlined">
                                            {isFilterVisible ? 'expand_less' : 'expand_more'}
                                        </span>
                                    </Button>
                                )}
                            </div>
                            <PaginationComponent
                                onPageChange={(value) => {
                                    document.getElementById('search-view').scrollIntoView()
                                    onHandlePage(value)
                                }}
                                totalProductCount={totalItems}
                                currentPage={formik.values.page}
                                resultToShow={formik.values.sh_limit}
                            />

                            <div className="auctionsMiscFilter">
                                {isWizardTheme ? null : (
                                    <div className="gridListToggle">
                                        <Button
                                            className={auctionView === 'Grid' ? 'active' : ''}
                                            onClick={() => setAuctionView('Grid')}
                                        >
                                            <span className="material-icons">apps</span>
                                        </Button>
                                        <Button
                                            className={auctionView === 'List' ? 'active' : ''}
                                            onClick={() => setAuctionView('List')}
                                        >
                                            <span className="material-icons">view_list</span>
                                        </Button>
                                    </div>
                                )}
                                <CustomSelect
                                    label="Results per page"
                                    name="resultsPerPage"
                                    selectType="noBorder"
                                    value={formik.values.sh_limit}
                                    size="small"
                                    onChange={(event, editor) => {
                                        formik.values.page = 1
                                        formik.setFieldValue('sh_limit', event.target.value)
                                        sessionStorage.setItem('sh_limit', event.target.value)
                                    }}
                                >
                                    {pageOptions.map((opt, optindex) => (
                                        <option value={opt.value}>{opt.show}</option>
                                    ))}
                                </CustomSelect>
                                <CustomSelect
                                    label="Sort by"
                                    value={formik.values.orderby}
                                    size="small"
                                    selectType="noBorder"
                                    name="orderby"
                                    // shrink={search.orderby !== '' ? true : false}
                                    onChange={(event, editor) => {
                                        {
                                            global?.storeConfigration?.liquidation_filter_update
                                                ?.value == 1 &&
                                            global?.storeConfigration?.liquidation_filter_update
                                                ?.value !== undefined
                                                ? handleSortByFilter(event)
                                                : formik.setFieldValue(
                                                      'orderby',
                                                      event.target.value,
                                                  )
                                        }
                                    }}
                                >
                                    {global?.storeConfigration?.liquidation_filter_update?.value ==
                                    1
                                        ? sortShow1.map((opt, optindex) => (
                                              <option value={opt.value}>{opt.show}</option>
                                          ))
                                        : sortShow.map((opt, optindex) => (
                                              <option value={opt.value}>{opt.show}</option>
                                          ))}
                                </CustomSelect>
                            </div>

                            <Button
                                className="toggleRespDrawer w-100"
                                variant="outlined"
                                onClick={toggleDrawer('bottom', true)}
                            >
                                <span className="material-icons">tune</span>
                                Filters
                            </Button>
                            {global?.storeConfigration?.liquidation_filter_update?.value == 1 ||
                            checkEmursTheme ||
                            isWizardTheme ||
                            checkBidShopTheme ? null : (
                                <CheckBox
                                    name="orderby"
                                    label="Time Remaining"
                                    className="asdasd"
                                    checked={checked}
                                    onChange={(event) => setChecked(!checked)}
                                />
                            )}
                        </div>
                    </>
                )}

                <div className="searchContainer">
                    <div className={`searchLt ${isFilterVisible ? '' : 'd-none'}`}>
                        <FilterPanel
                            formik={formik}
                            // filterValues={isWizardTheme ? wizardFilterValues : filterValues}
                            filterValues={filterValues}
                            allOpen={true}
                            locationInfo={isBidDepotProject ? true : null}
                            clearSearch={checkBidShopTheme ? handleFilterDeleteAll : false}
                        />
                    </div>

                    <div className={`searchRt ${isFilterVisible ? null : 'expandMore'}`}>
                        {isLoading ? (
                            <div>
                                <Loaders name="product_grid_view" isLoading={isLoading} loop={6} />
                            </div>
                        ) : viewProduct?.length !== 0 ? (
                            <div
                                className={`lotResults mb-4 ${auctionView} liquidationBuyCard ${
                                    !isAuthenticated ? 'unauth' : 'auth'
                                }`}
                            >
                                {viewProduct.map((data, index) =>
                                    auctionView === 'Grid' ? (
                                        <>
                                            {
                                                <GridProduct
                                                    data={data}
                                                    viewProduct={viewProduct}
                                                    setViewProduct={setViewProduct}
                                                    className={data.auction ? 'auction' : 'buynow'}
                                                    key={index}
                                                    type={data.auction ? 'auction' : 'buynow'}
                                                    selectedProduct={selectedProduct}
                                                    link={`/gallery/product-view/${data.id}`}
                                                    handleClick={handleClick}
                                                    timerTheme={isPrimeBids ? 'gFThemeTimer' : ''}
                                                    bidStatus={true}
                                                    sliderTheme="multiseller"
                                                    setAuctionIdRedirect={setAuctionIdRedirect}
                                                    currencyType={isWizardTheme ? '' : 'cad'}
                                                    timerIcon={true}
                                                    cardTheme="liquidationTwo"
                                                    bidBtnLabel={
                                                        isWizardTheme ? 'Bid Now' : 'Place Bid'
                                                    }
                                                    showDateNumber={2}
                                                    setModalOpen={setModalOpen}
                                                />
                                            }
                                        </>
                                    ) : (
                                        <MultisellerListCard
                                            cardTheme="liquidationTwo"
                                            lotData={data}
                                            viewProduct={viewProduct}
                                            setViewProduct={setViewProduct}
                                            className={data.auction ? 'auction' : 'buynow'}
                                            key={index}
                                            bidStatus={true}
                                            selectedProduct={selectedProduct}
                                            allsearchitems={viewProduct}
                                            type="lot"
                                            setAuctionIdRedirect={setAuctionIdRedirect}
                                            handleClick={handleClick}
                                            setModalOpen={setModalOpen}
                                            details={`/gallery/product-view/${data.id}`}
                                            sliderTheme="multiseller"
                                            card_theme="liquidationTwo"
                                            bidBtnLabel={
                                                <>
                                                    <span className="material-icons-outlined">
                                                        gavel
                                                    </span>
                                                    Bid
                                                </>
                                            }
                                        />
                                    ),
                                )}
                            </div>
                        ) : (
                            <NoRecordsFound />
                        )}

                        {/* {checkThemeClassName && (
                            <Button
                                className="filterButtonMobile"
                                id="filterButtonMobile"
                                variant="outlined"
                                onClick={toggleDrawer('bottom', true)}
                            >
                                Filters
                            </Button>
                        )} */}

                        <PaginationComponent
                            onPageChange={(value) => {
                                document.getElementById('search-view').scrollIntoView()
                                onHandlePage(value)
                            }}
                            totalProductCount={totalItems}
                            currentPage={formik.values.page}
                            resultToShow={formik.values.sh_limit}
                        />
                    </div>
                </div>
            </div>
            {isWizardTheme && (
                <>
                    <Popup
                        modaltitle="Auction Terms and Conditions"
                        modalClass="termsPop"
                        open={modalOpen}
                        handleClose={() => setModalOpen(false)}
                    >
                        <div>
                            <table className="termsTable">
                                <tbody>
                                    <tr>
                                        <td className="termsTableThree">
                                            <strong>Location:</strong> Address
                                            <br />
                                            <strong>Hours of operation:</strong>
                                        </td>
                                        <td className="termsTableTwo">
                                            <p>
                                                ALL items in this auction{' '}
                                                <strong>start at $1 with no reserve.</strong>
                                            </p>

                                            <p>
                                                <strong>Item Conditions:</strong> Items are listed
                                                as{' '}
                                                <strong>
                                                    Like New, Open Box, Damaged, or For Parts.
                                                </strong>
                                            </p>

                                            <p>
                                                Please refer to the [Terms and Conditions] for
                                                complete condition definitions. We do not test all
                                                items for full functionality. “Open Box” items may
                                                be{' '}
                                                <strong>
                                                    new, used, incomplete, damaged, or mislabeled
                                                </strong>
                                                .
                                            </p>

                                            <p>
                                                We rely on manufacturer descriptions and do our best
                                                to describe each item accurately, but{' '}
                                                <strong>
                                                    we cannot guarantee 100% accuracy. We strongly
                                                    recommend that all bidders personally inspect
                                                    items prior to placing bids.
                                                </strong>
                                            </p>

                                            <p>
                                                <strong>
                                                    All items are sold AS-IS. No returns or refunds
                                                    will be accepted for any reason.
                                                </strong>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="termsTableTwo">
                                            <strong>Location:</strong>
                                            <br />
                                            <strong>Date & Time:</strong>
                                            <br />
                                            <strong>Payment:</strong>
                                            <br />
                                            <strong>Removal:</strong>
                                            <br />
                                            <strong>Fees:</strong>
                                        </td>
                                        <td className="termsTableTwo">
                                            <p>
                                                <strong>Location:</strong>{' '}
                                                {viewProduct[idOfProduct]?.address},
                                                {viewProduct[idOfProduct]?.auction_state},{' '}
                                                {viewProduct[idOfProduct]?.country}
                                            </p>
                                            <p>
                                                <strong>Date & Time:</strong>{' '}
                                                {new Date(
                                                    viewProduct[idOfProduct]?.date_closed,
                                                ).toDateString()}
                                            </p>
                                            <p>
                                                <strong>Payment:</strong> The credit card on file
                                                will be automatically charged upon auction close. No
                                                cash or alternative payments will be accepted.
                                            </p>
                                            <p>
                                                <strong>Removal:</strong> Please bring your{' '}
                                                <strong>emailed receipt</strong> to pick up items
                                                during <strong>posted pickup hours.</strong>
                                                <br />
                                                Items must be picked up no later than{' '}
                                                <RemovalDate
                                                    apiDate={viewProduct[idOfProduct]?.date_closed}
                                                />
                                                .
                                                <br /> Items not removed by the deadline will be
                                                <strong> considered abandoned,</strong> and{' '}
                                                <strong>no refunds</strong> will be issued.
                                            </p>
                                            <p>
                                                <strong>Fees:</strong> A{' '}
                                                <strong>13% Buyer&apos;s Premium</strong>
                                                will be added to all winning bids.
                                            </p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="terms">
                            <PrimaryButton label="Accept" onClick={updateTermsStatus} />
                        </div>
                    </Popup>
                </>
            )}
            <Drawer
                anchor="bottom"
                open={state['bottom']}
                className="responsiveFilterDrawer"
                onClose={toggleDrawer('bottom', false)}
                onOpen={toggleDrawer('bottom', true)}
            >
                <div
                    className={clsx(classes.list, 'bottom')}
                    role="presentation"
                    // onClick={toggleDrawer('bottom', false)}
                    onKeyDown={toggleDrawer('bottom', false)}
                >
                    <FilterPanel
                        clearSearch={checkBidShopTheme ? handleFilterDeleteAll : false}
                        formik={formik}
                        filterValues={filterValues}
                    />
                </div>
            </Drawer>
            <MultisellerSlider
                storeTheme="Liquidation_two"
                selectedLot={selectedProduct}
                handleClose={handleClose}
                currency="cad"
                type={props.type ? props.type : ''}
            />
            <React.Fragment>
                <SwipeableDrawer
                    className="respHeaderSearch"
                    anchor={'top'}
                    open={state['top']}
                    disableBackdropTransition={!iOS}
                    disableDiscovery={iOS}
                    disableSwipeToOpen={false}
                    onClose={toggleDrawer('top', false)}
                    onOpen={toggleDrawer('top', true)}
                >
                    <HeaderSearchComponent />
                </SwipeableDrawer>
            </React.Fragment>
        </Layout>
    )
}

export default AuctionSearchComponent
